(function(){
  let savedScrollY = 0;
  let prevHtmlOverflow = '';
  let prevHtmlScrollBehavior = '';
  let prevBodyPaddingRight = '';

  function lockBody(){
    if (document.body.classList.contains('pa-modal-open')) return; /* already locked */
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    /* Compensate for scrollbar disappearance to avoid layout shift */
    const scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    prevBodyPaddingRight = document.body.style.paddingRight;
    if (scrollbarW > 0) document.body.style.paddingRight = scrollbarW + 'px';
    /* Disable smooth-scroll so any scroll restore is instant */
    prevHtmlScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    /* Lock scroll via overflow:hidden — no position:fixed → no jump */
    prevHtmlOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('pa-modal-open');
  }

  function unlockBody(){
    if (!document.body.classList.contains('pa-modal-open')) return;
    document.body.classList.remove('pa-modal-open');
    document.documentElement.style.overflow = prevHtmlOverflow;
    document.body.style.paddingRight = prevBodyPaddingRight;
    document.documentElement.style.scrollBehavior = prevHtmlScrollBehavior;
    /* Make sure scroll position hasn't drifted (some browsers do reset) */
    if ((window.scrollY || window.pageYOffset || 0) !== savedScrollY) {
      window.scrollTo(0, savedScrollY);
    }
  }

  function openModal(modal){
    if(!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    lockBody();
  }
  function closeModal(modal){
    if(!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');

    // als er geen enkele modal open is: body unlock
    if(!document.querySelector('.pa-modal.is-open')){
      unlockBody();
    }
  }

  document.addEventListener('click', function(e){
    // OPEN
    const opener = e.target.closest('[data-pa-open-modal]');
    if(opener){
      const id = opener.getAttribute('data-pa-open-modal');
      const target = document.getElementById(id);

      // Als dit een "stap 2" knop is: eerst parent modal sluiten
      if(opener.hasAttribute('data-pa-close-parent')){
        closeModal(opener.closest('.pa-modal'));
      }

      openModal(target);
      return;
    }

    // CLOSE
    const closer = e.target.closest('[data-pa-close-modal]');
    if(closer){
      closeModal(e.target.closest('.pa-modal'));
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    closeModal(document.querySelector('.pa-modal.is-open'));
  });
})();
